import * as React from "react";
import {Fragment} from "react";

class Pane extends React.Component {

	constructor(props) {
		super(props);
	}

	render() {

		const {id, iterator, selected, children} = this.props;

		return (
			<Fragment>
				<div className={`tab-pane fade${selected ? ' show active' : ''}`} id={`${id}-tab`} role="tabpanel" aria-labelledby={`${id}-tab`} tabIndex={iterator} >
					<div className="my-5">
						{children}
					</div>
				</div>
			</Fragment>
		);
	}
}

export default Pane;
